export enum AccessTypeAnalytics {
  Passive = 'Passive',
  Limited = 'Limited',
  Full = 'Full',
  Admin = 'Admin'
}

export interface User {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  name?: string; // Full name combination
  accountType: AccountType;
  companyId: number;
  companyName?: string | null; // Returned by backend, avoids client-side lookup
  license_type?: string;

  // Position and role
  branch?: string; // Branch for BranchAdmin
  subCompany?: string; // Sub-company for CompanyAdmin and BranchAdmin
  subCustomerId?: number; // Sub-customer ID for SubCustomerAdmin

  // Analytics access
  accessTypeAnalytics?: AccessTypeAnalytics;

  // Additional contact
  mail?: string; // Business email

  // Security and storage
  dataStorageKey?: string;
  passKey?: string;

  // Profile
  profileImageUrl?: string;

  // 2FA status
  totpEnabled?: boolean;

  // Status and timestamps
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  lastLogin?: string;

  // Impersonation fields
  isImpersonating?: boolean;
  originalUser?: {
    id: number;
    email: string;
  };
}

export enum AccountType {
  SubCustomerAdmin = 2,  // Can only see their specific sub-customer data
  BranchAdmin = 3,      // Can only see their specific branch data
  SubCompanyAdmin = 4,     // Can see all branches in their sub-company
  User = 5,
  LicenseeAdmin = 6,
  CarbonCareAdmin = 7,   // New Role
  MasterAdmin = 8,
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface SetPasswordData {
  token: string;
  password: string;
  confirmPassword: string;
}

export interface SignupData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  companyId?: number;
}

export interface AuthResponse {
  user: User;
  token: string;
  message: string;
}

// ==================== 2FA TOTP Types ====================

export interface TwoFactorSetupResponse {
  secret: string;
  qrCode: string; // Base64 data URL
}

export interface TwoFactorVerifySetupData {
  code: string;
  secret: string;
}

export interface TwoFactorVerifySetupResponse {
  backupCodes: string[];
}

export interface TwoFactorVerifyData {
  userId: number;
  code: string;
  useBackupCode?: boolean;
}

export interface TwoFactorDisableData {
  password: string;
}

export interface TwoFactorRegenerateBackupCodesData {
  password: string;
}

export interface TwoFactorStatusResponse {
  enabled: boolean;
}

export interface LoginResponseWith2FA {
  requires2FA: boolean;
  userId?: number;
  email?: string;
  user?: User;
  token?: string;
}